module.exports = __webpack_public_path__ + "mainassets/img/404.2a18a920.svg";